<template>
  <div class="index" v-bind:style="{ backgroundImage: 'url(' + bg_img + ')' }">
    <h3 class="animated fadeInLeft">联系<span>我们</span></h3>
    <p class="animated fadeInLeft">北京游梓网络科技有限公司</p>
    <div class="contact-right">
      <img
        class="index-bottom animated fadeInLeft"
        src="https://cdn.hanlandglobal.com/h5-contactUs-bg.png"
      />
      <div class="right nimated fadeIn">
        <img v-if="code" @click="flip" class="twoCode" :src="twoCode" />
        <img v-if="!code" @click="flip" class="twoCode animated flipInY" :src="mini_code" />
        <div class="fily" @click="flip">点击查看小程序</div>
        <h4>北京公司地址</h4>
        <div class="addss">{{ company.address }}</div>
        <h4>服务邮箱</h4>
        <div class="addss">{{ company.email }}</div>
        <h4>服务热线</h4>
        <div class="addss">{{ company.service_hotline }}</div>
        <div @click="goIndex" class="black"><img :src="black_img" /><span>返回首页</span></div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import bg_img from '../assets/image/h5-bg.png';
import twoCode from '../assets/image/twoCode.png';
import mini_code from '../assets/image/mini-code.jpg';
import black_img from '../assets/image/black.png';

export default {
  name: 'Home',
  data() {
    return {
      bg_img,
      mini_code,
      twoCode,
      black_img,
      code: true,
      company: {},
    };
  },
  created() {
    const company = localStorage.getItem('company');
    this.company = company
      ? JSON.parse(company)
      : {
          address: '北京市朝阳区广顺北大街33号院1号楼（五、十、十一层）1单元1682号',
          email: 'hello@uziliving.com',
          service_hotline: '010-84059883',
        };
  },
  mounted() {},
  methods: {
    flip() {
      if (this.code) {
        this.code = false;
      } else {
        this.code = true;
      }
    },
    goIndex() {
      this.$router.push('/');
    },
  },
};
</script>
<style lang="scss" scoped>
.index {
  width: 100%;
  height: 100vh;
  background-repeat: no-repeat;
  background-size: 100% 100vh;
  position: relative;
}
h3 {
  font-size: 0.54rem;
  font-family: SourceHan;
  color: #4d372e;
  text-align: left;
  letter-spacing: 1px;
  padding-top: 13vh;
  font-weight: normal;
  margin-left: 0.8rem;
  span {
    font-size: 0.72rem;
  }
}
p {
  font-family: SourceHan;
  font-size: 0.34rem;
  font-weight: bold;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #4d372e;
  text-align: left;
  margin-left: 0.8rem;
}
.index-bottom {
  width: 3.46rem;
  max-height: 8rem;
  position: absolute;
  left: 0;
  bottom: 0;
  display: block;
}
.contact-right {
  .right {
    width: 3.2rem;
    position: absolute;
    bottom: 0.2rem;
    right: 0.4rem;
    text-align: right;
  }
  h4 {
    font-family: SourceHan;
    font-size: 0.26rem;
    font-weight: bold;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #e27aa0;
    margin-top: 0.18rem;
  }
  .addss {
    font-family: SourceHan;
    font-size: 0.26rem;
    font-weight: bold;
    letter-spacing: 0px;
    color: #543f3c;
    line-height: 0.5rem;
  }
}
.fily {
  margin-bottom: 0.5rem;
  font-family: SourceHan;
  font-size: 0.2rem;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #e27aa0;
  margin-top: 0.1rem;
}
.twoCode {
  width: 1.38rem;
  height: 1.38rem;
}
.black {
  width: 1rem;
  margin-left: 2.2rem;
  img {
    width: 0.48rem;
    height: 0.48rem;
    display: block;
    margin-left: 0.4rem;
  }
  font-family: SourceHan;
  color: #e27aa0;
  font-size: 0.2rem;
}
</style>
